<template>
    <small>
        <b-overlay :show="!items" class="overlay" opacity="1">
            <b-table :fields="fields" :items="items" small bordered table-class="print-table small-text" class="mb-0" show-empty>
                <template #empty>
                    <div class="text-center my-2 fs-5">
                        No hay reuniones que coincidan con los criterios de búsqueda
                    </div>
                </template>
            
                <template #cell(information)="data">
                    <div class="information-container">
                        <div><small><b>Fecha creación</b>: {{ formatDateTime(data.item.creationDate) }}</small></div>
                        <div><small><b>Fecha inicio</b>: {{ formatDateTime(data.item.dateStart) }}</small></div>
                        <div><small><b>Duración</b>: {{ getDuration(data.item.dateStart, data.item.dateEnd) }}</small></div>
                        <div v-if="!isVirtual(data)">
                            <small><b>Ubicación</b>: {{ data.item.address }}</small>
                        </div>
                        <div v-else>
                            <small><b>Ubicación</b>: Virtual</small>
                        </div>
                    </div>
                </template>

                <template #cell(details)="data">
                    <div>
                        <small><b>Título</b>: {{ data.item.summary }}</small>
                        <br>
                        <small><b>Descripción</b>: {{ data.item.description }}</small>
                    </div>
                </template>

                <template #cell(assistants)="data">
                    <small>
                        <div>
                            <b>Organizador</b>: {{ data.item.organizer }}
                        </div>
                        <div>
                            <b>Invitados</b>:
                            <ul class="minimal-list">
                                <li v-for="(assistant, index) in data.item.assistants" :key="index">
                                    {{ formatAssistantName(assistant) }} ({{ assistant.mail }})
                                </li>
                            </ul>
                        </div>
                    </small>
                </template>

                <template #cell(comments)="data">
                    <small>
                        <ul class="minimal-list">
                            <li v-for="(comment, index) in data.item.comments" :key="index">
                                {{ formatComment(comment)}}
                            </li>
                        </ul>
                    </small>
                </template>
            </b-table>
        </b-overlay>
    </small>
</template>

<script>
import { formatAssistantName, formatDateTime, formatComment } from '@/plugins/complianceScripts/index.js'

export default {
    name: 'MeetingReportTable',

    props: {
        items: Array,
    },

    data() {
        return {
            fields: [
                {
                    key: 'details',
                    label: 'Reunión',
                    thClass: "text-center col-3",
                    tdClass: "align-middle"
                },
                {
                    key: 'information',
                    label: 'Información',
                    thClass: "text-center col-3",
                    tdClass: "text-left"
                },
                {
                    key: 'assistants',
                    label: 'Asistentes',
                    thClass: "text-center col-3",
                    tdClass: "text-left"
                },
                {
                    key: 'comments',
                    label: 'Comentarios',
                    thClass: "text-center col-3",
                    tdClass: "text-left",
                },
            ]
        }
    },

    methods: {
        formatDateTime,
        formatAssistantName,
        formatComment,
        
        getDuration(dateStart, dateEnd) {
            let totalMinutes = Math.floor((new Date(dateEnd) - new Date(dateStart)) / (1000 * 60));
            let hours = Math.floor(totalMinutes / 60);
            let minutes = totalMinutes % 60;

            let hoursString = hours === 1 ? 'hora' : 'horas';
            let minutesString = minutes === 1 ? 'minuto' : 'minutos';

            if (hours === 0) {
                return `${minutes} ${minutesString}`;
            } else if (minutes === 0) {
                return `${hours} ${hoursString}`;
            }

            return `${hours} ${hoursString} y ${minutes} ${minutesString}`;
        },

        isVirtual(row) {
            return row.item.place === 'virtualPlace'
        },
    }
}
</script>

<style scoped>
.small-text {
    font-size: 0.875em;
}

.small-text th {
    font-size: 0.875em;
    font-weight: bold;
}

.information-container > div {
    margin: 0.2rem 0;
}

.minimal-list {
    list-style: none;
    padding-left: 0.2rem;
    margin: 0.2rem 0;
    padding-left: 1em;
}

.minimal-list li::before {
    content: "- ";
    display: inline-block;
    width: 1em;
    margin-left: -1em;
}

hr {
    margin: 0.2rem 0;
    color: grey;
}
</style>